import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';

@Injectable()
export class MenuEffects {
  constructor(private actions$: Actions) {}
}
